import { render, staticRenderFns } from "./people-liked-you.vue?vue&type=template&id=1f81c55b&"
import script from "./people-liked-you.vue?vue&type=script&lang=js&"
export * from "./people-liked-you.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports